import * as React from 'react';
import { makeStyles, Theme, createStyles, withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import HttpsRoundedIcon from '@material-ui/icons/HttpsRounded';
import MailRoundedIcon from '@material-ui/icons/MailRounded';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';
import { Hidden } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      height: '7vh'
    },
    colorHeader: {
      backgroundColor: '#303F9F',
      color: '#FFFFFF',
      position: 'fixed'
    },
    title: {
      flexGrow: 1
    },
    logo: {
      // padding: '6px 0px',
      height: '70px',
      width: 'auto'
    },
    link: {
      textDecoration: 'none',
      color: 'currentColor'
    }
  })
);

const IconButtons = withStyles({
  // root: {
  //   '& .MuiButtonBase-root': {
  //     cursor: 'none !importent'
  //   },
  //   '& .MuiIconButton-root': {
  //     '&:hover': {
  //       backgroundColor: 'none !importent',
  //     },
  //   }
  // }
})(IconButton);

export default function Header() {
  const classes = useStyles({});

  return (
    <div className={classes.root}>
      <AppBar position="static" className={classes.colorHeader}>
        <Toolbar>
          <img src="/assets/logoheader.png" title="EasyDent" className={classes.logo} />
          {/* { } */}
          <Typography variant="h6" className={classes.title}>
            &nbsp;
          </Typography>
          <IconButtons
            aria-label="show 4 new mails"
            color="inherit"
            disabled
          />
          <HttpsRoundedIcon style={{ fontSize: 25, color: '#ffffff' }} />
          <Tooltip title="Sign In" aria-label="add">
            <Link to={'/login'} className={classes.link}>
              <Button color="inherit">Sign In</Button>
            </Link>
          </Tooltip>
          <Hidden xsDown>
            <IconButtons
              aria-label="show 4 new mails"
              color="inherit"
              disabled
            />
            <PersonAddIcon style={{ fontSize: 25, color: '#ffffff' }} />
            <Tooltip title="Sign Up" aria-label="add">
              <Link to={'/signup'} className={classes.link}>
                <Button color="inherit">Sign Up</Button>
              </Link>
            </Tooltip>
            <IconButtons
              aria-label="show 4 new mails"
              color="inherit"
              disabled
            />
            <MailRoundedIcon style={{ fontSize: 25, color: '#ffffff' }} />
            <Tooltip title="Contact" aria-label="add">
              <Link to={'/contact'} className={classes.link}>
                <Button color="inherit">Contact Us</Button>
              </Link>
            </Tooltip>
          </Hidden>
        </Toolbar>
      </AppBar>
    </div >
  );
}



// WEBPACK FOOTER //
// ./src/components/layouts/Header.tsx